<template>
  <div class="new-user">
    <div class="card flex-between" @click="join">
      <div class="left">
        <div class="title">加入机构</div>
        <div class="desc">如果您的机构正在体验或已购买云校，请联系管理员将您添加为员工</div>
      </div>
    </div>
    <div class="card flex-between" @click="$router.push('/baseOrganizationAdd?login=true')">
      <div class="left">
        <div class="title">创建新机构</div>
        <div class="desc">如果您是机构负责人，首次使用云校请先创建机构</div>
      </div>
      <div class="right">
        <van-icon name="arrow" size="18"></van-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'newUser',
  data() {
    return {
      pageTitle: '选择机构'
    };
  },
  methods: {
    join() {
      vant.Dialog.alert({
        title: '提示',
        message: '请联系机构管理员将您添加为员工哦',
        confirmBtnText: '我知道了',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.new-user {
  .card {
    padding: 12px 16px;
    margin: 16px;
    border-radius: 8px;
    background: var(--white);
    .left {
      width: 80%;
    }
    .title {
      font-size: var(--fs-lg);
      line-height: var(--lh-lg);
      font-weight: var(--bold);
      color: var(--g8);
    }
    .desc {
      margin-top: 8px;
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      color: var(--g6);
    }
  }
}
</style>

</style>